export default "__VITE_ASSET__h5i$yvNZ__"